const localStorageKeyQueue = 'queue';
const localStorageKeyWatched = 'watched';
export { localStorageKeyQueue, localStorageKeyWatched };
